<div class="khts-inline-notification">
    @if (iconName) {
        <span class="material-symbols-outlined khts-inline-notification__icon">
            {{ iconName }}
        </span>
    }
    <span>
        <ng-content></ng-content>
    </span>
</div>
